import(/* webpackMode: "eager" */ "/root/repo/src/app/page.tsx");
